<template>
  <div class="inventory">
    <div class="inventory-btn">
      <font-awesome-icon icon="warehouse" />
    </div>
    <draggable :list="inventory" group="pc" class="inventory__list">
      <pc-parts v-for="(part, i) in inventory" :part="part" :key="i" />
    </draggable>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PcParts from '../components/PcParts.vue'
import draggable from 'vuedraggable'

export default {
  name: 'Inventory',
  components: {
    draggable,
    'pc-parts': PcParts
  },
  data: ()=>({
    mouse: false
  }),
  computed: {
    ...mapState([
      'inventory'
    ])
  },
  created(){
    this.$store.dispatch('fetchInventory');
  }
}
</script>

<style>
.inventory{
  padding: 20px 15px;
  background-color: rgba(100, 100, 100, 75%);
  height: 100vh;

  position: fixed;
  top: 0;
  right: -400px;
  transition: 0.7s;
}

.inventory:hover{
  right: 0
}

.inventory__list{
  height: calc(100% - 40px);
  overflow-y: auto;
  overflow-x: hidden;
}

.inventory-btn{
  color: #fff;
  position: absolute;
  top: 0;
  right: 100%;
  background-color: rgba(100, 100, 100, 75%);
  width: 40px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
